import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/landlord/others/help-tags";
const category_resouce = "/landlord/others/help-tag-categories";
export default {
  get(pageNumber = 1, pagination = defaultPagination, filterQuery) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getHelpTagDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  createHelpTag(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateHelpTag(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  statusChangeHelpTag(id, status) {
    return Repository.put(`${resource}/${id}/${status}`)
  },
  getTagCategories(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${category_resouce}?paginate=${pagination}&page=${pageNumber}`)
  },
  createHelpTagCategory(payload){
    return Repository.post(`${category_resouce}`, payload)
  },
  updateHelpTagCategory(id, payload){
    return Repository.put(`${category_resouce}/${id}`, payload)
  },
  getTagCategoryDetails(id) {
    return Repository.get(`${category_resouce}/${id}`)
  },
};
